import { settings } from '@pixi/settings';

/**
 * Default `canvasPadding` for canvas-based Mesh rendering.
 *
 * @see PIXI.Mesh2d#canvasPadding
 * @static
 * @constant
 * @memberof PIXI.settings
 * @member {number} MESH_CANVAS_PADDING
 * @default 0
 */
settings.MESH_CANVAS_PADDING = 0;

export { settings };
